import { FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { InputField } from '@web/utils/src';
import { IFormInput } from '../types';

interface NamesScreenProps {
  register: UseFormRegister<IFormInput>;
  errors: FieldErrors<IFormInput>;
  setValue: UseFormSetValue<IFormInput>;
  formValues: IFormInput;
}

export const NamesScreen = ({
  register,
  errors,
  setValue,
}: NamesScreenProps) => {
  const { t } = useTranslation();

  const renderInputFields = () => (
    <div className="mt-2-0 grid grid-cols-1 gap-2-0">
      <InputField
        register={register}
        errors={errors}
        name="givenName"
        required
        setValue={setValue}
        t={t}
      />
      <InputField
        register={register}
        name="familyName"
        errors={errors}
        setValue={setValue}
        required
        t={t}
      />
    </div>
  );

  const renderTermsCheckbox = () => (
    <div className="mt-4-0 mb-2-0">
      <div className="flex">
        <div>
          <input
            type="checkbox"
            {...register('userTerms', {
              required: t('create_user_modal.accept_terms_and_conditions'),
            })}
            className="accent-primary-yellow w-1-5 h-1-5 rounded-14-0 mr-1-2"
            onChange={(e) => setValue('userTerms', !!e.target.checked)}
            role="terms-checkbox"
          />
        </div>
        <p className="text-body1">
          <Trans
            i18nKey="create_user_modal.accept_terms"
            components={[
              <Link
                key="accept_terms"
                to="/terms-and-conditions"
                className="font-bd"
              />,
              <strong key="accept_terms" />,
            ]}
          />
        </p>
      </div>
      {errors.userTerms && (
        <p className="absolute text-1-2 italic text-red">
          {errors.userTerms.message}
        </p>
      )}
    </div>
  );

  const renderMarketingCheckbox = () => (
    <div className="my-2-0 flex">
      <div>
        <input
          type="checkbox"
          className="accent-primary-yellow w-1-5 h-1-5 rounded-14-0 mr-1-2"
          onChange={(e) => setValue('userMarketing', !!e.target.value)}
        />
      </div>
      <p className="text-body1">
        <Trans i18nKey="create_user_modal.accept_marketing" />
      </p>
    </div>
  );

  return (
    <div className="mb-2-0" role="names-screen">
      <p className="font-bd text-body1">
        {t('create_user_modal.create_account')}
      </p>
      {renderInputFields()}
      {renderTermsCheckbox()}
      {renderMarketingCheckbox()}
    </div>
  );
};

export default NamesScreen;
